import React from "react";
import { FaBaby } from "react-icons/fa";
import { GiQueenCrown, GiSharpCrown, GiWool, GiFamilyHouse } from "react-icons/gi";

const DashboardTab = ({ productCounts, handleNavigate }) => {
  return (
    <>
      <div className="card men" onClick={() => handleNavigate("Mens")}>
        <GiQueenCrown className="icon" />
        <div className="men-image" />
        <div className="bubble-number">{productCounts.Men}</div>
        <h3>Mens</h3>
      </div>

      <div className="card kids" onClick={() => handleNavigate("Kids")}>
        <FaBaby className="icon" />
        <div className="kids-image" />
        <div className="bubble-number">{productCounts.Kid}</div>
        <h3>Kids</h3>
      </div>
      <div
        className="card women"
        onClick={() => handleNavigate("Womens")}
      >
        <GiSharpCrown className="icon" />
        <div className="women-image" />
        <div className="bubble-number">{productCounts.Women}</div>
        <h3>Womens</h3>
      </div>
      <div
        className="card fabric"
        onClick={() => handleNavigate("Fabric")}
      >
        <GiWool className="icon" />
        <div className="fabric-image" />
        <div className="bubble-number">{productCounts.Fabric}</div>
        <h3>Fabric</h3>
      </div>
      <div
        className="card home-accessories"
        onClick={undefined}
        style={{ cursor: "not-allowed", opacity: 0.7 }}
      >
        <GiFamilyHouse className="icon" />
        <div className="home-image" />
        <div className="bubble-number">
          {productCounts["Home-accessories"]}
        </div>
        <h3>Homes</h3>
      </div>
    </>
  );
};

export default DashboardTab;
